module.exports = __webpack_public_path__ + "static/img/Logo_YES.55615c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo_YES.png
// module id = 16
// module chunks = 0